import React from 'react';
import { Loader2, Plus, Search } from 'lucide-react';
import { Button } from '../../../ui/Button';

export interface SelectAsyncSearchHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  placeholder: string;
  allowCreateNew: boolean;
  /** When provided, Create New button is shown and this is called on click (parent should close and clear). */
  onCreateNewClick?: () => void;
  createNewLabel: string;
  isSearching: boolean;
  optionsLength: number;
}

export function SelectAsyncSearchHeader({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  placeholder,
  allowCreateNew,
  onCreateNewClick,
  createNewLabel,
  isSearching,
  optionsLength,
}: SelectAsyncSearchHeaderProps) {
  return (
    <div className="flex-shrink-0 flex items-center gap-2 border-b px-3 py-2 bg-white">
      <div className="flex-1 flex items-center">
        {isSearching ? (
          <Loader2 className="mr-2 h-4 w-4 shrink-0 opacity-50 animate-spin" />
        ) : (
          <Search className="mr-2 h-4 w-4 shrink-0 opacity-50" />
        )}
        <input
          type="text"
          placeholder={searchPlaceholder || `Search ${placeholder?.toLowerCase()}...`}
          value={searchValue}
          onChange={e => onSearchChange(e.target.value)}
          className="flex h-8 w-full rounded-md bg-transparent text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
      {allowCreateNew &&
        onCreateNewClick &&
        !(optionsLength === 0 && !isSearching) && (
          <Button
            variant="secondary"
            size="sm"
            className="flex-shrink-0 h-8 px-3"
            onClick={e => {
              e.stopPropagation();
              onCreateNewClick();
            }}>
            <Plus className="w-4 h-4 mr-1" />
            {createNewLabel}
          </Button>
        )}
    </div>
  );
}
